module.exports = __webpack_public_path__ + "static/4-c413a3df7e990bd198f80244a6fc6144.jpg";